import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { MediaPlaylistDto } from '@/types/dtos/media/media-playlist.dto.ts';
import type { SequencedPlaybackSettingsDto } from '@/types/dtos/media/virtual-media.dto.ts';
import { patchMediaPlaylistInQueryCache } from '@/state/mutations/media/patch-media-playlist-cache.ts';

export const usePatchVirtualMediaPlaybackMutation = () => {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async ({
      playlistId,
      slug,
      playback,
    }: {
      playlistId: string;
      slug: string;
      playback: SequencedPlaybackSettingsDto;
    }) => {
      const token = await getToken();
      return patchVirtualMediaPlayback(playlistId, slug, playback, token ?? '');
    },
    onSuccess: (updatedPlaylist) => {
      patchMediaPlaylistInQueryCache(queryClient, updatedPlaylist);
    },
  });
};

const patchVirtualMediaPlayback = async (
  playlistId: string,
  slug: string,
  playback: SequencedPlaybackSettingsDto,
  token: string,
): Promise<MediaPlaylistDto> => {
  const url = `${import.meta.env.VITE_API_URL}/media-playlists/${playlistId}/virtual-media/${encodeURIComponent(slug)}/playback`;
  return sendJSONRequest({ url, method: METHOD.PATCH, body: playback, token });
};
